import React from 'react';

export const HospitalName: React.FC = () => {
  return null;
};

export default HospitalName;
